import React from "react";
import "../../sass/landing/psya.scss";
import PsyaBusto from "../../assets/psya/psya-busto.webp";

const PsyaNote = () => (
  <section className="lp-psya" aria-labelledby="psya-title">
    <div className="lp-shell lp-psya__grid">
      <div className="lp-psya__identity">
        <img
          src={PsyaBusto}
          alt="Ilustração da PSYA, a assistente do PsyAssist."
          width="500"
          height="500"
          loading="lazy"
          decoding="async"
          className="lp-psya__avatar"
        />
        <span className="lp-psya__label">Uma ajuda no dia a dia</span>
      </div>

      <h2 id="psya-title">A PSYA ajuda a organizar. A análise é sua.</h2>

      <div className="lp-psya__text">
        <p>
          A PSYA utiliza o contexto registrado por você para organizar
          informações e gerar sugestões que podem apoiar sua análise, sempre sob
          revisão do psicólogo. Ela não faz diagnóstico nem define condutas.
        </p>
        <p className="lp-psya__plan">Disponível no plano Premium.</p>
      </div>
    </div>
  </section>
);

export default PsyaNote;
